<template>
  <div
    class="d-flex position-relative cursor-pointer"
    data-testid="searchbar-league-item"
    @mousedown="onCardClick()"
  >
    <v-container fluid v-if="league" class="px-1 pb-1 pt-1">
      <v-row>
        <v-col cols="2" class="px-3 py-0 d-flex justify-center align-center">
          <img
            :src="
              'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/' + league.id + '.png'
            "
            :height="28"
            contain
            @error="onImageLoadFailure($event)"
          />
        </v-col>
        <v-col
          cols="10"
          class="pl-2 pr-0 py-0 d-flex flex-column justify-center"
        >
          <div class="d-flex flex-column">
            <div class="d-flex align-center justify-space-between">
              <div class="d-flex flex-grow-1">
                <span class="body-2 primary--text">{{
                  league.name
                }}</span>
              </div>
              <div
                class="d-flex align-center"
                v-if="!$vuetify.breakpoint.smAndDown && league.cC"
              >
                <DriblabCountryFlag :iso="league.cC"></DriblabCountryFlag>
                <small class="primary--text mx-2"
                  >{{ $t(`iso.${league.cC.toUpperCase()}`) }}</small
                >
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DriblabCountryFlag from '../base/DriblabCountryFlag';

export default {
  name: "LeagueSearchItem",
  components: {
    DriblabCountryFlag
  },
  filters: {
  },
  created() {},
  props: {
    league: {
      type: Object,
      default: false,
    },
    allowRouter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCardClick() {
      if (this.allowRouter) {
        this.$router.push(`/league/${this.league.id}`);
      }
    },
    onImageLoadFailure(event) {
      event.target.src = "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png";
    },
  },
};
</script>
